export enum UserTier {
  OFF = "Off",
  FREE = "Free",
  TIER_1 = "Tier 1",
  TIER_2 = "Tier 2",
  TIER_3 = "Tier 3",
}
